module.exports = __webpack_public_path__ + "ipetbooking-landing/img/pic02@1.f733f97e.jpg";